import { Fragment, memo, ReactNode, useMemo, useState } from 'react';

import { isEmpty, isNonNullish } from 'remeda';
import useSWR from 'swr';

import TextField from '@mui/material/TextField';

import { DraggablePartnerSpotlightCards } from './draggablePartnerSpotlightCards/DraggablePartnerSpotlightCards';
import { filterPartnerSpotlightsByQuery } from './utils/filterPartnerSpotlightsByQuery';

import css from './PartnerSpotlights.module.css';

import { casinoService } from 'v2/api/casinoService';
import { partnerSpotlightService } from 'v2/api/partnerSpotlightService';
import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Loader } from 'v2/components/loader/Loader';

export const PartnerSpotlights = memo(() => {
  const [searchQuery, setSearchQuery] = useState('');
  const { data, isLoading, mutate } = useSWR('getPartnerSpotlights', partnerSpotlightService.getPartnerSpotlights);
  const { data: casinos } = useSWR('getCasinos', casinoService.getCasinos);

  const filteredSpotlights = useMemo(
    () => (isNonNullish(data) ? filterPartnerSpotlightsByQuery(data, searchQuery, casinos) : []),
    [data, searchQuery, casinos]
  );

  const hasActiveSearch = searchQuery.trim().length > 0;

  if (isLoading) {
    return <Loader />;
  }

  if (!isNonNullish(data)) {
    return false;
  }

  let listSection: ReactNode;

  if (isEmpty(data)) {
    listSection = <EmptyPlaceholder />;
  } else if (hasActiveSearch && isEmpty(filteredSpotlights)) {
    listSection = <EmptyPlaceholder text="Nothing found" />;
  } else {
    listSection = (
      <DraggablePartnerSpotlightCards
        partnerSpotlights={filteredSpotlights}
        onRevalidate={mutate}
        dragDisabled={hasActiveSearch}
        hideEmptyGroups={hasActiveSearch}
      />
    );
  }

  return (
    <Fragment>
      <div className={css.partnerSpotlightsToolbar}>
        <TextField
          fullWidth
          size="small"
          label="Search by casino name"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          variant="outlined"
        />
      </div>

      {listSection}
    </Fragment>
  );
});

PartnerSpotlights.displayName = 'PartnerSpotlights';
